/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { SuccessResponse_FinanceStatementsResponse_ } from '../models/SuccessResponse_FinanceStatementsResponse_';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class FinanceStatementsService {
    /**
     * Get Finance Statements Endpoint
     * @returns SuccessResponse_FinanceStatementsResponse_ Successful Response
     * @throws ApiError
     */
    public static getFinanceStatementsEndpointApiV1FinanceStatementsStoreIdGet({
        storeId,
        year,
        month,
    }: {
        storeId: number,
        year: number,
        month: number,
    }): CancelablePromise<SuccessResponse_FinanceStatementsResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/finance-statements/{store_id}',
            path: {
                'store_id': storeId,
            },
            query: {
                'year': year,
                'month': month,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
